import React from "react";
import { Table } from "react-bootstrap"
import Text from "../../../../_components/Text";
import LoadingContainer from "../../../../_components/LoadingContainer";
import Template from "./Template";
import { getCOFINS } from "../../../../api/products/taxes";
import { cofinsCstdata } from "./Template"

export default props => {
    const [loading, setLoading] = React.useState(true)
    const [data, setData] = React.useState([])
    const [cofins, setCOFINS] = React.useState({})
    const ref = React.useRef(null)


    function onSave() {
        const reload = () => window.location.reload()
        setTimeout(reload, 3000)
    }
    function onEdit(item) {
        setCOFINS({
            ...item
        })
    }
    function onClose() {
        setCOFINS({})
    }

    function init() {
        getCOFINS(data).then(resp => {
            setData(resp.reverse())
            setLoading(false)
        })
    }
    React.useEffect(init, [ref.current])

    return <React.Fragment>
        <LoadingContainer loading={loading} ref={ref}>
            <div className="container">
                <div className="row py-3">
                    <div className="col-12 my-3">
                        <Text as="h2"> Templates de COFINS </Text>
                        <Template
                            show={cofins.id != undefined}
                            data={cofins}
                            onClose={onClose}
                            onSave={onSave} />
                    </div>
                    <div className="col-md-12">
                        <Table bordered hover>
                            <thead>
                                <tr>
                                    <th>Descrição COFINS</th>
                                    <th>CST COFINS</th>
                                    <th>Alíquota COFINS</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.map((cofins, idx) => {
                                        const cst = cofinsCstdata.find(item => item.value === cofins.cst)
                                        return <tr>
                                            <td>
                                                {
                                                    cofins.name
                                                }
                                            </td>
                                            <td>
                                                {
                                                    cst.value
                                                }
                                                &nbsp;-&nbsp;
                                                {
                                                    cst.label
                                                }
                                            </td>
                                            <td>
                                                {
                                                    cofins.p_cofins
                                                } %
                                            </td>
                                            <td>
                                                <i
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => { onEdit(cofins) }}
                                                    className="fas fa-edit" />
                                            </td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </LoadingContainer>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/COFINS/index.jsx